// extracted by mini-css-extract-plugin
var _1 = "ApplicantFitCheckBlockBreakdown-moduleApplicantFitCheckBlockBreakdown__KrE_j";
var _2 = "ApplicantFitCheckBlockBreakdown-modulecolumnTitle__xVO_i";
var _3 = "ApplicantFitCheckBlockBreakdown-moduledisclaimer__K8XSJ";
var _4 = "ApplicantFitCheckBlockBreakdown-moduleexcluded__HDfR0";
var _5 = "ApplicantFitCheckBlockBreakdown-modulefooter__DSIGy";
var _6 = "ApplicantFitCheckBlockBreakdown-moduleformula__GEqCh";
var _7 = "ApplicantFitCheckBlockBreakdown-modulenumeral__xplmm";
var _8 = "ApplicantFitCheckBlockBreakdown-modulerow__zOaAD";
var _9 = "ApplicantFitCheckBlockBreakdown-moduletotal__jRJtT ApplicantFitCheckBlockBreakdown-modulerow__zOaAD";
export { _1 as "ApplicantFitCheckBlockBreakdown", _2 as "columnTitle", _3 as "disclaimer", _4 as "excluded", _5 as "footer", _6 as "formula", _7 as "numeral", _8 as "row", _9 as "total" }
